import { Area, Branch, City } from "../types/item";
import { OrderType } from "../types/enums";

export const toCityOptions = (cities: City[] = []) =>
  cities.map((city) => ({ label: city.name, value: city.uuid }));

export const toAreaOptions = (areas: Area[] = []) =>
  areas
    .filter((area) => area.isActive ?? true)
    .map((area) => ({ label: area.name, value: area.uuid }));

export const toBranchOptions = (branches: Branch[] = []) =>
  branches
    .filter((branch) => branch.isActive ?? true)
    .map((branch) => ({ label: branch.name, value: branch.uuid }));

export const resolveStoredLocation = (cities: City[], stored: any) => {
  const city = cities.find((item) => item.uuid === stored?.city);
  if (!city) return null;
  const area = city.areas?.find(
    (item) => item.uuid === stored?.area && (item.isActive ?? true),
  );
  const branch = city.branches?.find(
    (item) => item.uuid === stored?.branch && (item.isActive ?? true),
  );
  if (stored?.orderType === OrderType.pickup)
    return branch ? { city, branch, orderType: OrderType.pickup } : null;
  return area ? { city, area, orderType: OrderType.delivery } : null;
};
